module.exports = __webpack_public_path__ + "img/e-seminar.f2f369b.png";